module.exports = __webpack_public_path__ + "img/qrcode.62a337ae.png";